/* tslint:disable */
/* eslint-disable */
/**
 * Bill Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { GetMobileResponse } from '../model';
// @ts-ignore
import { OrganizationPaxGroupsResponse } from '../model';
// @ts-ignore
import { PreviousPaxOrderByType } from '../model';
// @ts-ignore
import { TravelerRequest } from '../model';
// @ts-ignore
import { TravelersHistoryResponse } from '../model';
// @ts-ignore
import { UserPaxListResponse } from '../model';
/**
 * PreviousPaxApiApiOrganizationGroupsGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiOrganizationGroupsGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/organization/groups`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiOrganizationPaxGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiOrganizationPaxGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/organization/pax`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPaxGroupIdDelete - axios parameter creator
 * 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPaxGroupIdDeleteAxiosParamCreator (id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiPaxGroupIdDelete', 'id', id)
    const localVarPath = `/api/pax/group/{id}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPaxGroupIdNameNamePut - axios parameter creator
 * 
 * @summary updates a pax group title
 * @param {number} id 
 * @param {string} name 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPaxGroupIdNameNamePutAxiosParamCreator (id: number, name: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiPaxGroupIdNameNamePut', 'id', id)
    // verify required parameter 'name' is not null or undefined
    assertParamExists('apiPaxGroupIdNameNamePut', 'name', name)
    const localVarPath = `/api/pax/group/{id}/name/{name}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"name"}}`, encodeURIComponent(String(name)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPaxGroupNamePost - axios parameter creator
 * 
 * @param {string} name 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPaxGroupNamePostAxiosParamCreator (name: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'name' is not null or undefined
    assertParamExists('apiPaxGroupNamePost', 'name', name)
    const localVarPath = `/api/pax/group/{name}`
        .replace(`{${"name"}}`, encodeURIComponent(String(name)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPost - axios parameter creator
 * 
 * @param {string} playerId 
 * @param {File} [file] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPostAxiosParamCreator (playerId: string, file?: File, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'playerId' is not null or undefined
    assertParamExists('apiPreviousPaxAddBatchPaxPlayerIdPost', 'playerId', playerId)
    const localVarPath = `/api/PreviousPax/AddBatchPax/{playerId}`
        .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;
    const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)


    if (file !== undefined) { 
        localVarFormParams.append('File', file as any);
    }


    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = localVarFormParams;

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxDefaultPassengerGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxDefaultPassengerGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/PreviousPax/DefaultPassenger`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxDeleteAllPaxDelete - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxDeleteAllPaxDeleteAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/PreviousPax/DeleteAllPax`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxExportPaxGet - axios parameter creator
 * 
 * @param {number} [userId] 
 * @param {string} [baseDate] 
 * @param {PreviousPaxOrderByType} [orderByType] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxExportPaxGetAxiosParamCreator (userId?: number, baseDate?: string, orderByType?: PreviousPaxOrderByType, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/PreviousPax/exportPax`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }

    if (baseDate !== undefined) {
        localVarQueryParameter['baseDate'] = (baseDate as any instanceof Date) ?
            (baseDate as any).toISOString() :
            baseDate;
    }

    if (orderByType !== undefined) {
        localVarQueryParameter['orderByType'] = orderByType;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxPlayerIdGet - axios parameter creator
 * 
 * @param {string} playerId 
 * @param {string} [baseDate] 
 * @param {PreviousPaxOrderByType} [orderByType] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxPlayerIdGetAxiosParamCreator (playerId: string, baseDate?: string, orderByType?: PreviousPaxOrderByType, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'playerId' is not null or undefined
    assertParamExists('apiPreviousPaxPlayerIdGet', 'playerId', playerId)
    const localVarPath = `/api/PreviousPax/{playerId}`
        .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (baseDate !== undefined) {
        localVarQueryParameter['baseDate'] = (baseDate as any instanceof Date) ?
            (baseDate as any).toISOString() :
            baseDate;
    }

    if (orderByType !== undefined) {
        localVarQueryParameter['orderByType'] = orderByType;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxPlayerIdIdDelete - axios parameter creator
 * 
 * @param {string} playerId 
 * @param {number} id 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxPlayerIdIdDeleteAxiosParamCreator (playerId: string, id: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'playerId' is not null or undefined
    assertParamExists('apiPreviousPaxPlayerIdIdDelete', 'playerId', playerId)
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiPreviousPaxPlayerIdIdDelete', 'id', id)
    const localVarPath = `/api/PreviousPax/{playerId}/{id}`
        .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxPlayerIdIdPut - axios parameter creator
 * 
 * @param {string} playerId 
 * @param {number} id 
 * @param {TravelerRequest} [travelerRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxPlayerIdIdPutAxiosParamCreator (playerId: string, id: number, travelerRequest?: TravelerRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'playerId' is not null or undefined
    assertParamExists('apiPreviousPaxPlayerIdIdPut', 'playerId', playerId)
    // verify required parameter 'id' is not null or undefined
    assertParamExists('apiPreviousPaxPlayerIdIdPut', 'id', id)
    const localVarPath = `/api/PreviousPax/{playerId}/{id}`
        .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)))
        .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(travelerRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxPlayerIdMobileGet - axios parameter creator
 * 
 * @param {string} playerId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxPlayerIdMobileGetAxiosParamCreator (playerId: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'playerId' is not null or undefined
    assertParamExists('apiPreviousPaxPlayerIdMobileGet', 'playerId', playerId)
    const localVarPath = `/api/PreviousPax/{playerId}/Mobile`
        .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxPlayerIdPost - axios parameter creator
 * 
 * @param {string} playerId 
 * @param {number} [userId] 
 * @param {TravelerRequest} [travelerRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxPlayerIdPostAxiosParamCreator (playerId: string, userId?: number, travelerRequest?: TravelerRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'playerId' is not null or undefined
    assertParamExists('apiPreviousPaxPlayerIdPost', 'playerId', playerId)
    const localVarPath = `/api/PreviousPax/{playerId}`
        .replace(`{${"playerId"}}`, encodeURIComponent(String(playerId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
    }



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(travelerRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxTravelerHistoryIdDelete - axios parameter creator
 * 
 * @param {number} travelerHistoryId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxTravelerHistoryIdDeleteAxiosParamCreator (travelerHistoryId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'travelerHistoryId' is not null or undefined
    assertParamExists('apiPreviousPaxTravelerHistoryIdDelete', 'travelerHistoryId', travelerHistoryId)
    const localVarPath = `/api/PreviousPax/{travelerHistoryId}`
        .replace(`{${"travelerHistoryId"}}`, encodeURIComponent(String(travelerHistoryId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxUserIdGet - axios parameter creator
 * 
 * @param {number} userId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxUserIdGetAxiosParamCreator (userId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiPreviousPaxUserIdGet', 'userId', userId)
    const localVarPath = `/api/PreviousPax/{userId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * PreviousPaxApiApiPreviousPaxUserIdPost - axios parameter creator
 * 
 * @param {number} userId 
 * @param {TravelerRequest} [travelerRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function PreviousPaxApiApiPreviousPaxUserIdPostAxiosParamCreator (userId: number, travelerRequest?: TravelerRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'userId' is not null or undefined
    assertParamExists('apiPreviousPaxUserIdPost', 'userId', userId)
    const localVarPath = `/api/PreviousPax/{userId}`
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(travelerRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiPaxGroupIdDelete operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPaxGroupIdDeleteRequest
 */
export interface PreviousPaxApiApiPaxGroupIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof PreviousPaxApiApiPaxGroupIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiPaxGroupIdNameNamePut operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPaxGroupIdNameNamePutRequest
 */
export interface PreviousPaxApiApiPaxGroupIdNameNamePutRequest {
    /**
     * 
     * @type {number}
     * @memberof PreviousPaxApiApiPaxGroupIdNameNamePut
     */
    readonly id: number

    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPaxGroupIdNameNamePut
     */
    readonly name: string
}

/**
 * Request parameters for apiPaxGroupNamePost operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPaxGroupNamePostRequest
 */
export interface PreviousPaxApiApiPaxGroupNamePostRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPaxGroupNamePost
     */
    readonly name: string
}

/**
 * Request parameters for apiPreviousPaxAddBatchPaxPlayerIdPost operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPostRequest
 */
export interface PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPost
     */
    readonly playerId: string

    /**
     * 
     * @type {File}
     * @memberof PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPost
     */
    readonly file?: File
}

/**
 * Request parameters for apiPreviousPaxExportPaxGet operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxExportPaxGetRequest
 */
export interface PreviousPaxApiApiPreviousPaxExportPaxGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PreviousPaxApiApiPreviousPaxExportPaxGet
     */
    readonly userId?: number

    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPreviousPaxExportPaxGet
     */
    readonly baseDate?: string

    /**
     * 
     * @type {PreviousPaxOrderByType}
     * @memberof PreviousPaxApiApiPreviousPaxExportPaxGet
     */
    readonly orderByType?: PreviousPaxOrderByType
}

/**
 * Request parameters for apiPreviousPaxPlayerIdGet operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxPlayerIdGetRequest
 */
export interface PreviousPaxApiApiPreviousPaxPlayerIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdGet
     */
    readonly playerId: string

    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdGet
     */
    readonly baseDate?: string

    /**
     * 
     * @type {PreviousPaxOrderByType}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdGet
     */
    readonly orderByType?: PreviousPaxOrderByType
}

/**
 * Request parameters for apiPreviousPaxPlayerIdIdDelete operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxPlayerIdIdDeleteRequest
 */
export interface PreviousPaxApiApiPreviousPaxPlayerIdIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdIdDelete
     */
    readonly playerId: string

    /**
     * 
     * @type {number}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiPreviousPaxPlayerIdIdPut operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxPlayerIdIdPutRequest
 */
export interface PreviousPaxApiApiPreviousPaxPlayerIdIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdIdPut
     */
    readonly playerId: string

    /**
     * 
     * @type {number}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdIdPut
     */
    readonly id: number

    /**
     * 
     * @type {TravelerRequest}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdIdPut
     */
    readonly travelerRequest?: TravelerRequest
}

/**
 * Request parameters for apiPreviousPaxPlayerIdMobileGet operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxPlayerIdMobileGetRequest
 */
export interface PreviousPaxApiApiPreviousPaxPlayerIdMobileGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdMobileGet
     */
    readonly playerId: string
}

/**
 * Request parameters for apiPreviousPaxPlayerIdPost operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxPlayerIdPostRequest
 */
export interface PreviousPaxApiApiPreviousPaxPlayerIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdPost
     */
    readonly playerId: string

    /**
     * 
     * @type {number}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdPost
     */
    readonly userId?: number

    /**
     * 
     * @type {TravelerRequest}
     * @memberof PreviousPaxApiApiPreviousPaxPlayerIdPost
     */
    readonly travelerRequest?: TravelerRequest
}

/**
 * Request parameters for apiPreviousPaxTravelerHistoryIdDelete operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxTravelerHistoryIdDeleteRequest
 */
export interface PreviousPaxApiApiPreviousPaxTravelerHistoryIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof PreviousPaxApiApiPreviousPaxTravelerHistoryIdDelete
     */
    readonly travelerHistoryId: number
}

/**
 * Request parameters for apiPreviousPaxUserIdGet operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxUserIdGetRequest
 */
export interface PreviousPaxApiApiPreviousPaxUserIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PreviousPaxApiApiPreviousPaxUserIdGet
     */
    readonly userId: number
}

/**
 * Request parameters for apiPreviousPaxUserIdPost operation in PreviousPaxApi.
 * @export
 * @interface PreviousPaxApiApiPreviousPaxUserIdPostRequest
 */
export interface PreviousPaxApiApiPreviousPaxUserIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof PreviousPaxApiApiPreviousPaxUserIdPost
     */
    readonly userId: number

    /**
     * 
     * @type {TravelerRequest}
     * @memberof PreviousPaxApiApiPreviousPaxUserIdPost
     */
    readonly travelerRequest?: TravelerRequest
}

/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiOrganizationGroupsGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiOrganizationGroupsGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<OrganizationPaxGroupsResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiOrganizationPaxGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiOrganizationPaxGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<UserPaxListResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPaxGroupIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPaxGroupIdDelete(requestParameters: PreviousPaxApiApiPaxGroupIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPaxGroupIdDeleteAxiosParamCreator(requestParameters.id, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary updates a pax group title
* @param {PreviousPaxApiApiPaxGroupIdNameNamePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPaxGroupIdNameNamePut(requestParameters: PreviousPaxApiApiPaxGroupIdNameNamePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPaxGroupIdNameNamePutAxiosParamCreator(requestParameters.id, requestParameters.name, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPaxGroupNamePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPaxGroupNamePost(requestParameters: PreviousPaxApiApiPaxGroupNamePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPaxGroupNamePostAxiosParamCreator(requestParameters.name, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPost(requestParameters: PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxAddBatchPaxPlayerIdPostAxiosParamCreator(requestParameters.playerId, requestParameters.file, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxDefaultPassengerGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxDefaultPassengerGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<TravelersHistoryResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxDeleteAllPaxDelete(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxDeleteAllPaxDeleteAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxExportPaxGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxExportPaxGet(requestParameters: PreviousPaxApiApiPreviousPaxExportPaxGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxExportPaxGetAxiosParamCreator(requestParameters.userId, requestParameters.baseDate, requestParameters.orderByType, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxPlayerIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxPlayerIdGet(requestParameters: PreviousPaxApiApiPreviousPaxPlayerIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxPlayerIdGetAxiosParamCreator(requestParameters.playerId, requestParameters.baseDate, requestParameters.orderByType, options, configuration);
    const request: () => AxiosPromise<Array<TravelersHistoryResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxPlayerIdIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxPlayerIdIdDelete(requestParameters: PreviousPaxApiApiPreviousPaxPlayerIdIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxPlayerIdIdDeleteAxiosParamCreator(requestParameters.playerId, requestParameters.id, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxPlayerIdIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxPlayerIdIdPut(requestParameters: PreviousPaxApiApiPreviousPaxPlayerIdIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxPlayerIdIdPutAxiosParamCreator(requestParameters.playerId, requestParameters.id, requestParameters.travelerRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxPlayerIdMobileGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxPlayerIdMobileGet(requestParameters: PreviousPaxApiApiPreviousPaxPlayerIdMobileGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxPlayerIdMobileGetAxiosParamCreator(requestParameters.playerId, options, configuration);
    const request: () => AxiosPromise<GetMobileResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxPlayerIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxPlayerIdPost(requestParameters: PreviousPaxApiApiPreviousPaxPlayerIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxPlayerIdPostAxiosParamCreator(requestParameters.playerId, requestParameters.userId, requestParameters.travelerRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxTravelerHistoryIdDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxTravelerHistoryIdDelete(requestParameters: PreviousPaxApiApiPreviousPaxTravelerHistoryIdDeleteRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxTravelerHistoryIdDeleteAxiosParamCreator(requestParameters.travelerHistoryId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxUserIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxUserIdGet(requestParameters: PreviousPaxApiApiPreviousPaxUserIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxUserIdGetAxiosParamCreator(requestParameters.userId, options, configuration);
    const request: () => AxiosPromise<Array<TravelersHistoryResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {PreviousPaxApiApiPreviousPaxUserIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function PreviousPaxApiApiPreviousPaxUserIdPost(requestParameters: PreviousPaxApiApiPreviousPaxUserIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await PreviousPaxApiApiPreviousPaxUserIdPostAxiosParamCreator(requestParameters.userId, requestParameters.travelerRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
